import { defineAction } from './types';

export default defineAction({
  action: 'CREATE_MEETING_AGENDA',
  getHref: attrs => `/meetings?eventId=${attrs.event_id}&generate_agenda=true`,
  getFollowUp: () => null,
  completionEvents: ['MEETING_AGENDA_GENERATED'],
});
